import { FC } from "preact/compat";
import { Dialog, IconButton } from "~/components";
import { FieldKey, PrintViewProps } from "./interfaces";
import ChevronLeftIcon from "@material-design-icons/svg/outlined/chevron_left.svg";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";
import Loader from "~/assets/loader.svg";

const FIELD_TITLES: Record<FieldKey, string> = {
    before: "Edit text before",
    after: "Edit text after",
};

const Mobile: FC<PrintViewProps> = ({
    thumbnails,
    settingsContent,
    isSettingsOpen,
    editingField,
    fieldSignals,
    closeEditor,
}) => (
    <>
        <div className="flex flex-col gap-y-3 p-4 pb-safe-14">
            {thumbnails.length === 0 && (
                <div className="flex justify-center py-8">
                    <Loader width="28" height="28" className="text-sky-500" />
                </div>
            )}
            {thumbnails.map((url, index) => (
                <img
                    key={index}
                    src={url}
                    alt=""
                    className="w-full rounded-2xl border border-gray-200 shadow-md"
                />
            ))}
        </div>
        <Dialog show={isSettingsOpen}>
            <div className="max-h-[80vh] w-[calc(100vw-40px)] max-w-[380px] overflow-y-auto rounded-2xl border border-gray-300 bg-white p-4 fill-current">
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-x-2">
                        {editingField.value && (
                            <IconButton title="Back" onClick={closeEditor}>
                                <ChevronLeftIcon width="20" height="20" />
                            </IconButton>
                        )}
                        <h3 className="text-xl">
                            {editingField.value
                                ? FIELD_TITLES[editingField.value]
                                : "Show/hide in layout"}
                        </h3>
                    </div>
                    <IconButton
                        title="Close"
                        onClick={() => (isSettingsOpen.value = false)}
                    >
                        <CloseIcon width="20" height="20" />
                    </IconButton>
                </div>
                {editingField.value ? (
                    <textarea
                        autofocus
                        className="h-[487.75px] w-full resize-none rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:ring focus:ring-sky-500 focus:ring-offset-2 focus:ring-offset-white"
                        placeholder="Type text here..."
                        value={fieldSignals[editingField.value].value}
                        onInput={({ currentTarget }) =>
                            (fieldSignals[
                                editingField.peek() as FieldKey
                            ].value = currentTarget.value)
                        }
                    />
                ) : (
                    settingsContent
                )}
            </div>
        </Dialog>
    </>
);

export default Mobile;
